import styled from 'styled-components';
import type { TenderEstimateDetail } from '@shared/api';
import { TenderTerritory } from '../TerritoryField';

const Fact = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};
  margin-top: ${({ theme }) => theme.spacing(3)};
  font-size: 13px;
`;

const FactLabel = styled.span`
  color: ${({ theme }) => theme.colors.text.muted};
`;

/** Категория местности расчёта по тендеру — по ней берётся ставка накладных
 *  расходов; показ и смена в карточке. */
export function TenderCalcFacts({
  detail,
  canWrite,
}: {
  detail: TenderEstimateDetail;
  canWrite: boolean;
}) {
  const estimate = detail.estimate;
  return (
    <Fact>
      <FactLabel>Категория местности:</FactLabel>
      <TenderTerritory
        key={estimate.id}
        estimateId={estimate.id}
        value={estimate.territory_category}
        resultValue={estimate.calc_territory_category}
        status={estimate.status}
        canEdit={canWrite}
      />
    </Fact>
  );
}
